import { render } from "./LabPage.vue?vue&type=template&id=41695e19&scoped=true"
import script from "./LabPage.vue?vue&type=script&lang=js"
export * from "./LabPage.vue?vue&type=script&lang=js"

import "./LabPage.vue?vue&type=style&index=0&id=41695e19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41695e19"]])

export default __exports__